export default "__VITE_ASSET__BJN3Ilf3__"